module.exports = __webpack_public_path__ + "static/media/uu.0a17afe6.jpeg";